import * as google_protobuf_timestamp_pb from 'google-protobuf/google/protobuf/timestamp_pb';
import {
  FileManagement,
} from 'src/app/proto/generated/inv_common_message_pb';
import { InventoryFile } from 'src/app/proto/generated/inv_api_message_pb';
import { OBaseModel } from '@olameter/o-utilities';

export class FileModel implements OBaseModel {
  name: string;
  thumbnail: string;
  file_name: string;
  file_url: string;
  timestamp: Date;

  static Mapper(file: InventoryFile): FileModel {
    return {
      name: file.getName(),
      thumbnail: file.getFileUrl(),
      file_name: file.getFileName() as string,
      file_url: file.getFileUrl() as string,
      timestamp: file.getTimeStamp().toDate(),
    };
  }

  static setWOPicturesUploadRequest(data) {
    const file: FileManagement = new FileManagement();
    file.setFileByte(data.bytes);
    file.setFileExtension(data.file.type);
    file.setFileName(data.file.name);
    file.setCreatedOn(FileModel.fromDateToTimestamp(new Date(Date.now())));
    file.setContractName(data.contractID);
    file.setInventoryName(data.woName);
    return file;
  }

  static fromDateToTimestamp(date: Date) {
    if (date == null) {
      return null;
    }
    const result = new google_protobuf_timestamp_pb.Timestamp();
    result.fromDate(new Date(date));
    return result;
  }
}
